export const CATALOG_NAME_MAX_LENGTH = 40;

export const catalogNameError = (value) => {
  if (!value.trim()) return "Enter a name.";
  if (Array.from(value.trim()).length > CATALOG_NAME_MAX_LENGTH) {
    return `Names must be ${CATALOG_NAME_MAX_LENGTH} characters or fewer.`;
  }
  return null;
};

export default function CatalogNameField({ id, label, value, onChange }) {
  const length = Array.from(value || "").length;
  return (
    <div className="formField">
      <label className="mainLabel" htmlFor={id}>{label}<span>*</span></label>
      <input id={id} className="themeInput" value={value} maxLength={CATALOG_NAME_MAX_LENGTH}
        required aria-describedby={`${id}_hint`} aria-invalid={length > CATALOG_NAME_MAX_LENGTH}
        onChange={(event) => onChange(event.target.value)} />
      <small id={`${id}_hint`} className={`fieldHint ${length > CATALOG_NAME_MAX_LENGTH ? "text-danger" : ""}`}>
        {length}/{CATALOG_NAME_MAX_LENGTH} characters. Use a short, descriptive name.
      </small>
    </div>
  );
}
